function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { useMemo, useState } from 'react';
import { sum } from 'lodash';
import { ErrorBoundary } from 'react-error-boundary';
import { Bleed, Button, Card, createForm, Dialog, DescriptionList, Flex, Link, Markdown, NumberInput, Text, Table, useToasts } from '@applyboard/crystal-ui';
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { EditOutlineIcon } from '@applyboard/ui-icons';
import { IllustratedErrorState } from "../../../../components/IllustratedErrorState";
import { TextareaWithCharacterLimit } from "../../../../components/TextareaWithCharacterLimit";
import { ApplicationActionName } from "../../../../types";
import { useApplicationAvailableActions, useSendApplicationAction } from "../../data";
import { useCommission } from "../../data/commission";
import { useCommissionHistory, usePrefetchCommissionHistory } from "../../data/commissionHistory";
import { useCommissionTransactions } from "../../data/commissionTransaction";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function CommissionTab(_ref) {
  var hiddenSections = _ref.hiddenSections;
  var _useEventTracker = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker.trackEvent;
  return _jsx(ErrorBoundary, {
    fallbackRender: function fallbackRender(_ref2) {
      var error = _ref2.error;
      return _jsx(IllustratedErrorState, {
        error: error,
        variant: "compact"
      });
    },
    onError: function onError(error) {
      return trackEvent({
        event: 'Single Application V2 - Commission Tab - Displayed Error',
        error: error
      });
    },
    children: _jsx(CommissionTabContents, {
      hiddenSections: hiddenSections
    })
  });
}
function CommissionTabContents(_ref3) {
  var hiddenSections = _ref3.hiddenSections;
  var _useTranslation = useTranslation('CommissionTab'),
    t = _useTranslation.t;
  var _useCommission = useCommission(),
    commission = _useCommission.commission;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  if (!commission) {
    return _jsx(Text, {
      children: t('commissionUnavailable')
    });
  }
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [!(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('rateDisclaimer')) && _jsx(Markdown, {
      markdown: t('rateDisclaimer'),
      headingSettings: {
        baseLevel: 2
      }
    }), _jsx(Card, {
      emphasis: "outlined",
      children: _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(DescriptionList, {
          variant: "free",
          children: _jsxs(Flex, {
            align: "center",
            gap: 2,
            children: [_jsx(DescriptionList.Term, {
              variant: "titleS",
              children: t('effectiveCommission')
            }), _jsx(DescriptionList.Details, {
              children: commission ? formatCommissionRate(commission.commissionRate) : '--'
            }), canPerformApplicationAction(ApplicationActionName.EDIT_COMMISSION) && _jsx(Bleed, {
              ml: 1,
              children: _jsx(EditRateButton, {})
            })]
          })
        }), _jsx(ViewHistoryButton, {})]
      })
    }), _jsx(CommissionTransactionsTable, {})]
  });
}
function formatCommissionRate(commissionRate) {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 2
  }).format(commissionRate / 100);
}
var _createForm = createForm(),
  EditRateForm = _createForm.Form,
  EditRateField = _createForm.Field;
function EditRateButton() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useTranslation2 = useTranslation('CommissionTab'),
    t = _useTranslation2.t;
  var _useSendApplicationAc = useSendApplicationAction(),
    sendApplicationAction = _useSendApplicationAc.sendApplicationAction,
    sendApplicationActionStatus = _useSendApplicationAc.sendApplicationActionStatus;
  var prefetchCommissionHistory = usePrefetchCommissionHistory();
  var toasts = useToasts();
  var _useCommission2 = useCommission(),
    commission = _useCommission2.commission;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        "aria-label": t('editRateDialog.title'),
        leadIcon: EditOutlineIcon,
        intent: "primary",
        emphasis: "transparent",
        size: "sm"
      })
    }), _jsx(Dialog.Heading, {
      children: t('editRateDialog.title')
    }), _jsx(Dialog.Content, {
      children: _jsx(EditRateForm, {
        id: "editRateForm",
        defaultValues: {
          commissionRate: (commission === null || commission === void 0 ? void 0 : commission.commissionRate.toString()) || '',
          comment: ''
        },
        onSubmit: function onSubmit(values) {
          return sendApplicationAction({
            actionId: ApplicationActionName.EDIT_COMMISSION,
            actionData: {
              commissionRate: values.commissionRate,
              comment: values.comment
            }
          }, {
            onSuccess: function onSuccess() {
              prefetchCommissionHistory();
              setIsOpen(false);
              toasts.positive(t('editRateDialog.success'));
            },
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              }
            }
          });
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 4,
          align: "start",
          children: [_jsx(EditRateField, {
            as: NumberInput,
            name: "commissionRate",
            min: 0,
            max: 100,
            label: t('editRateDialog.effectiveRate'),
            required: t('editRateDialog.requiredError'),
            validate: function validate(value) {
              var rate = Number(value);
              if (rate < 1 || rate > 100) {
                return t('editRateDialog.rateValueError');
              }
              return true;
            }
          }), _jsx(Flex.Item, {
            width: "fill",
            children: _jsx(EditRateField, {
              as: TextareaWithCharacterLimit,
              name: "comment",
              label: t('editRateDialog.comment'),
              required: t('editRateDialog.requiredError'),
              helpText: t('editRateDialog.commentHelpText'),
              validate: function validate(value) {
                if (value.length > 500) {
                  // Returning an empty string to use the default error message here
                  return '';
                }
                return true;
              },
              characterLimit: 500
            })
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('editRateDialog.cancel')
      }), _jsx(Button, {
        intent: "primary",
        type: "submit",
        form: "editRateForm",
        loading: sendApplicationActionStatus === 'loading',
        width: "fill",
        children: t('editRateDialog.save')
      })]
    })]
  });
}
function ViewHistoryButton() {
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var _useTranslation3 = useTranslation('CommissionTab'),
    t = _useTranslation3.t;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    size: "lg",
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Link, {
        as: "button",
        variant: "standalone",
        onClick: function onClick() {},
        children: _jsx(Text, {
          children: t('rateHistoryDialog.button')
        })
      })
    }), _jsx(Dialog.Heading, {
      children: t('rateHistoryDialog.title')
    }), _jsx(Dialog.Content, {
      children: _jsx(CommissionHistoryTable, {})
    }), _jsx(Dialog.Actions, {
      children: _jsx(Flex, {
        justify: "end",
        basis: "100%",
        children: _jsx(Dialog.CloseButton, {
          intent: "primary",
          emphasis: "outlined",
          children: t('rateHistoryDialog.close')
        })
      })
    })]
  });
}
function CommissionHistoryTable() {
  var _commissionHistory$;
  var _useCommissionHistory = useCommissionHistory(),
    commissionHistory = _useCommissionHistory.commissionHistory,
    commissionHistoryStatus = _useCommissionHistory.commissionHistoryStatus,
    commissionHistoryError = _useCommissionHistory.commissionHistoryError;
  var firstItemId = (_commissionHistory$ = commissionHistory[0]) === null || _commissionHistory$ === void 0 ? void 0 : _commissionHistory$.id;
  var _useTranslation4 = useTranslation('CommissionTab'),
    t = _useTranslation4.t;
  var columns = useMemo(function () {
    return [{
      accessorKey: 'commissionRate',
      header: t('rateHistoryDialog.commissionRate'),
      width: 'content',
      cell: function cell(item) {
        return _jsx(Table.Cell, {
          children: _jsxs(Text, {
            overflow: "nowrap",
            children: [formatCommissionRate(item.commissionRate), ' ', item.id === firstItemId ? t('rateHistoryDialog.current') : '']
          })
        });
      }
    }, {
      accessorKey: 'comment',
      header: t('rateHistoryDialog.comment'),
      cell: function cell(item) {
        return _jsx(Table.Cell, {
          children: _jsx(Text, {
            children: item.comment || '--'
          })
        });
      }
    }, {
      accessorKey: 'createdAt',
      header: t('rateHistoryDialog.date'),
      width: 'content',
      cell: function cell(item) {
        return _jsx(Table.Cell, {
          children: _jsx(Text, {
            overflow: "nowrap",
            children: new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            }).format(new Date(item.createdAt))
          })
        });
      }
    }];
  }, [firstItemId, t]);
  if (commissionHistoryError) {
    return _jsx(IllustratedErrorState, {
      error: commissionHistoryError,
      variant: "compact"
    });
  }
  return _jsx(Table, {
    loading: commissionHistoryStatus === 'loading',
    columns: columns,
    data: commissionHistory
  });
}
function CommissionTransactionsTable() {
  var _useTranslation5 = useTranslation('CommissionTab'),
    t = _useTranslation5.t;
  var _useCommissionTransac = useCommissionTransactions(),
    commissionTransactions = _useCommissionTransac.commissionTransactions;
  if (!(commissionTransactions !== null && commissionTransactions !== void 0 && commissionTransactions.length)) {
    return null;
  }
  var totalAmount = sum(commissionTransactions.map(function (transaction) {
    return transaction.total;
  }));
  var currency = commissionTransactions[0].currency;
  var columns = [{
    accessorKey: 'dateOfTransaction',
    header: t('paymentHistoryTable.date'),
    cell: function cell(transaction) {
      return _jsx(Table.DateCell, {
        format: "MMMM dd, yyyy",
        value: transaction.dateOfTransaction
      });
    }
  }, {
    accessorKey: 'total',
    header: t('paymentHistoryTable.amount'),
    cell: function cell(transaction) {
      return _jsx(Table.Cell, {
        children: _jsx(Text, {
          intent: transaction.total > 0 ? 'positive' : 'negative',
          contrast: "mid",
          children: formatAmount(transaction.total, transaction.currency)
        })
      });
    }
  }, {
    accessorKey: 'transactionNote',
    header: t('paymentHistoryTable.note'),
    cell: function cell(transaction) {
      return _jsx(Table.Cell, {
        children: _jsx(Text, {
          children: transaction.transactionNote || '--'
        })
      });
    }
  }];
  return _jsx(Card, {
    emphasis: "outlined",
    children: _jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [_jsx(DescriptionList, {
        variant: "free",
        children: _jsxs(Flex, {
          align: "center",
          gap: 2,
          children: [_jsx(DescriptionList.Term, {
            variant: "titleS",
            children: t('paymentHistoryTable.totalCommission')
          }), _jsx(DescriptionList.Details, {
            children: _jsx(Text, {
              children: formatAmount(totalAmount, currency)
            })
          })]
        })
      }), _jsx(Text, {
        variant: "titleS",
        id: "paymentHistoryTableTitle",
        children: t('paymentHistoryTable.title')
      }), _jsx(Table, {
        columns: columns,
        "aria-labelledby": "paymentHistoryTableTitle",
        data: commissionTransactions,
        loading: false
      })]
    })
  });
}
function formatAmount(amount, currency) {
  var formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'narrowSymbol'
  }).format(amount / 100);
  return "".concat(formattedAmount, " ").concat(currency);
}